import React from "react";
import useCheckAuthentication from "./hooks/useCheckAuthentication";
import { useAppDispatch, useAppSelector } from "./redux";
import { getLoggedUserDetailSagaAction } from "./redux/saga/auth/saga-actions";
import AppRoutes from "./AppRoutes";

const App: React.FC<{}> = (props) => {
  const dispatch = useAppDispatch();
  const [authenticationStatus, authenticationConsoleArray] =
    useCheckAuthentication();
  const { loggedUserDetail } = useAppSelector((state) => state.auth);

  React.useEffect(() => {
    if (
      authenticationStatus &&
      !loggedUserDetail &&
      localStorage.getItem("user-email")
    ) {
      dispatch(getLoggedUserDetailSagaAction());
    }
  }, [authenticationStatus]);

  return (
    <div className="App">
      <AppRoutes authenticationStatus={authenticationStatus} />
    </div>
  );
};

export default App;
